import React from 'react';
import { asyncComponent } from 'react-async-component';
import Loading from '../../asyncComps/Loading';

export default asyncComponent({
    resolve: () => import('./Status'),
    LoadingComponent: ()=>{
        return (
            <Loading ecId={`${this && this.props && this.props.ecId || ''}_Loading@kx6o0i`} />
        )
    }
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/status/StatusAsync.js